<div class="linearList-container">
  <ul cdkDropList id="{{listfor}}" [cdkDropListData]="models">
    <li (mouseover)="selected=i" (mouseout)="selected=-1" [ngClass]="{'selected' : active && selected == i}"
      class="{{model._type}} ellipsis" *ngFor="let model of models; let i = index;" (dblclick)="list.onClick(model)"
      cdkDrag (CdkDragSortEvent)="moveElement($event)" (cdkDragStarted)="onDragStarted($event)" (cdkDragEnded)="onDragEnded($event)">
      <div class="cell">
        <div class="cell1">
          <span class="list-icon {{model._type}} {{model.type}}"></span>
          <span class="list-title" matTooltip="{{model[list.listItemHeadingProperyName]}}">{{model[list.listItemHeadingProperyName]}}</span>
        </div>
        <div class="cell2">
          <mat-icon uk-tooltip="More" [hidden]="!contextAvailable" (click)="setMoreMenuModel(model)"
            [matMenuTriggerFor]="appMenu" [matMenuTriggerData]="{data:model}" class="context-menu-icon"
            aria-hidden="false" aria-label="Cotext Icon">more_vert
          </mat-icon>
        </div>
      </div>
    </li>
  </ul>
</div>
<mat-menu #appMenu="matMenu">
  <ng-template matMenuContent let-data="data">
    <button mat-menu-item (click)="editModel(data)"> <mat-icon matTooltip="Edit">edit</mat-icon></button>
    <button mat-menu-item (click)="deleteModel(data)"> <mat-icon matTooltip="Delete">delete</mat-icon></button>
    <button mat-menu-item (click)="saveAsModel(data)"> <mat-icon matTooltip="Copy"> file_copy</mat-icon></button>
    <button mat-menu-item (click)="openCodeLinkageView(data)" *ngIf="isLibrary()" [featureNavState]="'CODE_REVIEW'" [showBadge]="false"> <mat-icon matTooltip="Link Code">
        code</mat-icon></button>
    <button mat-menu-item (click)="createEnvFile(data)" [featureNavState]="'CI_CD'" [showBadge]="false"> <mat-icon matTooltip="CI/CD Template">
        check_circle</mat-icon></button>
  </ng-template>
</mat-menu>